export enum SpinnerColorEnum {
  PRIMARY = 'primary',
  GRAY = 'gray',
  WHITE = 'white'
}